(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sme-product-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sme-product-quote')) {
    customElements.define('sme-product-quote', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.form = this.querySelector('form');
        if (!this.details || !this.form) return;
        this.quantityEdited = Boolean(this.querySelector('[data-quote-result]'));
        this.onToggle = () => {
          if (this.details.open) this.syncProduct(true);
        };
        this.onSubmit = () => this.syncProduct(false);
        this.onQuantityInput = () => { this.quantityEdited = true; };
        this.details.addEventListener('toggle', this.onToggle);
        this.form.addEventListener('submit', this.onSubmit);
        this.querySelector('[data-quote-quantity]').addEventListener('input', this.onQuantityInput);
        const result = this.querySelector('[data-quote-result]');
        if (result) {
          this.details.open = true;
          requestAnimationFrame(() => result.focus());
        }
      }
      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.onToggle);
        this.form?.removeEventListener('submit', this.onSubmit);
        this.querySelector('[data-quote-quantity]')?.removeEventListener('input', this.onQuantityInput);
      }
      syncProduct(syncQuantity) {
        const sectionId = this.dataset.sectionId;
        const productForm = document.getElementById('product-form-' + sectionId);
        const variantInput = productForm?.querySelector('input[name="id"]');
        if (!variantInput) return;
        const variantId = variantInput.value;
        const sku = document.getElementById('Sku-' + sectionId)?.textContent.trim().replace(/^[^:]*:\s*/, '') || '';
        const productUrl = new URL(this.dataset.productUrl, window.location.origin);
        if (variantId) productUrl.searchParams.set('variant', variantId);
        this.querySelector('[data-quote-variant]').value = variantId;
        this.querySelector('[data-quote-sku]').value = sku;
        this.querySelector('[data-quote-url]').value = productUrl.href;
        if (syncQuantity && !this.quantityEdited) {
          const quantity = Number(document.getElementById('Quantity-' + sectionId)?.value);
          this.querySelector('[data-quote-quantity]').value = Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
